<template>
  <div :class="classnames" data-test-id="app-reviews">
    <div class="app-reviews__container container flex flex-col items-center">
      <b-headline type="h1" typography="h2" :responsive="false" class="mb-12 text-center px-8 m:px-0">
        {{ $t("features.appReviews.headline") }}
      </b-headline>

      <div class="grid">
        <div class="app-reviews__user-reviews">
          <user-reviews />
        </div>
      </div>

      <div class="main-features__cta flex justify-center mb-8 m:mb-16 w-full" v-if="!hideCta">
        <slot name="cta">
          <start-trial-button-with-pricing
            event-category="body-20210610-app_reviews"
            :signup-route="signupRoute"
            :show-trial-end-date="showTrialEndDate"
            :cta-copy="ctaCopy"
          />
        </slot>
      </div>
      <growth-stats class="mb-8 m:mb-16" />
      <div class="main-features__cta flex justify-center w-full" v-if="!hideCta">
        <slot name="cta">
          <start-trial-button-with-pricing
            event-category="body-20210610-app_reviews"
            :signup-route="signupRoute"
            :show-trial-end-date="showTrialEndDate"
            :cta-copy="ctaCopy"
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { UserReviews } from "@/component-library/user-reviews"
import BHeadline from "@/component-library/b-headline"
import StartTrialButtonWithPricing from "@/shared/start-trial-button-with-pricing"
import globals from "@/utils/globals"
import bemBlockModifiers from "@/utils/bem-block-modifiers"
import i18n from "@/modules/i18n"
import GrowthStats from "@/features/growth-stats"

export default {
  name: "AppReviews",
  components: {
    GrowthStats,
    BHeadline,
    UserReviews,
    StartTrialButtonWithPricing
  },
  props: {
    signupRoute: {
      type: String,
      required: false,
      default: ""
    },
    showTrialEndDate: {
      type: Boolean,
      default: false
    },
    hideCta: {
      type: Boolean,
      default: false
    },
    ctaCopy: {
      type: String,
      required: false,
      default: null
    },
    modifiers: {
      type: Array,
      default: () => {}
    }
  },
  computed: {
    formattedHeadline() {
      return this.$t("userReviews.headline", {
        totalUsers: globals.totalUsers
      })
    },
    classnames() {
      return bemBlockModifiers("app-reviews", this.modifiers)
    }
  },
  i18n: i18n
}
</script>

<style lang="scss">
.inherit-font-attributes {
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
}

.app-reviews {
  &:not(&--pt-0) {
    padding: $spacing-48 0;
  }

  &__platforms {
    margin-bottom: $spacing-48;
  }

  &__platform {
    &:first-child {
      margin-bottom: $spacing-24;
    }

    @include media(min-width, m) {
      &:first-child {
        margin-bottom: 0;
      }
    }
  }

  &__user-reviews {
    @include grid-css-element(12);

    @include media(min-width, m) {
      @include grid-css-element(8, 3);
    }
  }

  &__ios {
    @include grid-css-element(12);

    @include media(min-width, m) {
      @include grid-css-element(5, 2);
    }
  }

  &__android {
    @include grid-css-element(12);

    @include media(min-width, m) {
      @include grid-css-element(5, 7);
    }
  }

  &__cta {
    margin-bottom: $spacing-16;

    text-align: center;
  }

  &__trial-info {
    @include font-style(caption);

    text-align: center;
  }

  @include media(min-width, m) {
    padding: 0 0 $spacing-64;

    &:not(&--pt-0) {
      padding: $spacing-64 0;
    }
  }
}
</style>
